var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "23px",
    viewBox: "0 0 38 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Foot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-44",
    transform: "translate(-197.000000, -327.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2558348,284.318148 C38.971551,289.778051 39.3573307,294.627618 39.4131739,298.866849 C38.8875074,301.995779 37.5966232,304.633136 35.5405212,306.778921 C32.5828087,305.9987 30.7053005,305.746726 29.9079964,306.022999 C28.0302179,305.660523 26.5256881,305.157214 25.394407,304.51307 C23.0838458,303.554786 21.9369788,302.567262 21.9538057,301.550497 C22.0037461,298.532866 25.1269215,296.851464 25.394407,295.066474 C27.3889926,292.168749 28.3816944,288.585973 28.3725123,284.318148 L38.2558348,284.318148 Z M52.9942848,284.318148 C52.9851027,288.585973 53.9778045,292.168749 55.9723901,295.066474 C56.2398756,296.851464 59.363051,298.532866 59.4129914,301.550497 C59.4298183,302.567262 58.2829513,303.554786 55.9723901,304.51307 C54.841109,305.157214 53.3365792,305.660523 51.4588007,306.022999 C50.6614966,305.746726 48.7839884,305.9987 45.8262759,306.778921 C43.7701739,304.633136 42.4792897,301.995779 41.9536232,298.866849 C42.0094664,294.627618 42.3952461,289.778051 43.1109623,284.318148 L43.1109623,284.318148 Z",
    id: "Foot"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/Foot.4467f3202bf416b88d2b951a9e03f690.svg";
export { ForwardRef as ReactComponent };